module.exports = __webpack_public_path__ + "static/tyrant02-sq-9c69fa58398086f0783a2c460dfcaafe.png";